
export default class BaseModel {

  constructor(data) {
    Object.assign(this, data)
  }

  // axiosのresponse dataをインスタンス化するconfigを取得する
  static get axios() {
    return {
      transformResponse: [data => {
        if(typeof data === 'string') {
          try {
            data = JSON.parse(data, (key, value) => {
              if(value instanceof Object && !Array.isArray(value)) {
                return new this(value)
              }
              return value
            })
          }
          // jsonの変換に失敗した場合は理由如何に問わず握り潰してオリジナルのデータを返す
          catch(e) {}
        }
        return data
      }],
    }
  }
}
